//In Frontend Masters they just...
//---------------------------------------------------
import firebase from "firebase";

var firebaseConfig = {
  apiKey: "AIzaSyDgb0TeAadNKC-5XfaXGzlgcV_r0-FV1gw",
  authDomain: "tp-app-bcd90.firebaseapp.com",
  databaseURL: "https://tp-app-bcd90-default-rtdb.firebaseio.com",
  projectId: "tp-app-bcd90",
  storageBucket: "tp-app-bcd90.appspot.com",
  messagingSenderId: "71312707336",
  appId: "1:71312707336:web:bd81c53a0f5dcb00aba6bd",
  measurementId: "G-2QPD8FYPHW"
};

const firebaseApp = firebase.initializeApp(firebaseConfig); //might need to be just -- firebase.initializeApp(firebaseConfig); and related to the 

export default firebaseApp; //My Initialized Instance of Firebase

//My two databases -- and I will need to choose one
//Using both is like using Vue & React in the same App
//For now I will keep both active, as I am still experimenting with various setups
//But one will need to be disabled
export const db = firebase.database(); //My Initialized Realtime Database
export const fireDB = firebase.firestore(); //My Initialized Firestore Database

// console.log(
//   "The firebase stuff from firebase.js -- it happened =]\r\n\r\nconsole log should have returned the database object"
// );
// console.log("database", db);
//---------------------------------------------------
//
//
//
//

//Vue Programming With Erik Method:
//---------------------------------------------------
// import firebase from "firebase/app";
// import "firebase/auth";

// //Your web app's Firebase Configuration
// var firebaseConfig = {
//   apiKey: "AIzaSyBccdau0v8X8L2r0xRV0Gc68V6Oi6xjUBE",
//   authDomain: "tp-app-52907.firebaseapp.com",
//   projectId: "tp-app-52907",
//   storageBucket: "tp-app-52907.appspot.com",
//   messagingSenderId: "614448580111",
//   appId: "1:614448580111:web:2372680f62e4d93ff1857a",
//   measurementId: "G-RZ65GN3EJE"
// };

// // Initialize Firebase
// firebase.initializeApp(firebaseConfig);
//---------------------------------------------------
